import ContextPopover from 'components/shared/context-menu/ContextPopover';
import ShareViewModal from './ShareViewModal';
import RenameViewModal from './RenameViewModal';
import DeleteViewModal from './DeleteViewModal';
import { useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import AddNewView from '../../../../components/shared/views/add-new-view/AddNewView';

import { toast } from 'react-toastify';

import classes from './ViewActions.module.scss';
import {
  CONFIGURE_VIEW,
  VIEW_CATEGORY,
  INSIGHT_TYPE_CODE,
  VIEW_ACTION_TYPE,
  MODAL_ACTION,
  UNDEFINED,
  BUTTON_STATE,
  COMPONENT_MAPPING,
} from 'constants/constants';
import { copyViewToMyView } from '../services/user-view.service';
import { setAllMView } from 'store/home/homeMyViewSlice';
import { copyViewToInsight } from 'store/customer/customer-view-actions';
import {
  setAllInsightView,
  setSaveInsightViewBtnState,
  setSelectedInsightView,
} from 'store/customer/customerViewSlice';
import SaveWarningModal from 'components/customer/section-menu/SaveWarningModal';
import {
  buildFilterPayload,
  getAccessibleFilters,
  scrollToSelectedView,
} from 'utils/utils';

export default function ViewActions({
  page,
  currentViewRecord,
  setAnchorEl,
  anchorEl,
  setViewModalShow,
  viewModalShow,
}) {
  const dispatch = useDispatch();
  const modalPromiseRef = useRef(null);
  const [showViewWarningModal, setShowViewWarningModal] = useState(false);
  const [openModal, setOpenModal] = useState({
    isShared: false,
    isDelete: false,
    isRename: false,
  });

  const custInsightsBrdId = useSelector(
    (state) => state?.CustomerView?.custInsightsBrdId
  );
  const allMViews = useSelector((state) => state?.HomeMyView?.allMViews);
  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );
  const saveInsightViewBtnState = useSelector(
    (state) => state?.CustomerView?.saveInsightViewBtnState
  );
  const engagementFilters = useSelector(
    (state) => state?.CustomerView?.engagementFilters
  );
  const sitePerformanceFilters = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters
  );
  const siteUtilizationFilters = useSelector(
    (state) => state?.CustomerView?.siteUtilizationFilters
  );
  const AffiliationFilter = useSelector(
    (state) => state?.CustomerView?.affiliationsFilters
  );
  const copayAnalyticsFilters = useSelector(
    (state) => state?.CustomerView?.copayAnalyticsFilters
  );
  const productMixFilters = useSelector(
    (state) => state?.CustomerView?.productMixFilters
  );
  const payerMixFilters = useSelector(
    (state) => state.CustomerView?.payerMixFilters
  );
  const policyDetailsFilters = useSelector(
    (state) => state.CustomerView?.policyDetailsFilters
  );
  const selectedInsightView = useSelector(
    (state) => state?.CustomerView?.selectedInsightView
  );

  const componentAccessList = useSelector(
    (state) => state?.Auth?.componentAccessList
  );
  const selectedView = useSelector(
    (state) => state?.CustomerView?.selectedView
  );
  const ecosystemOpportunityFilters = useSelector(
    (state) => state.CustomerView?.ecosystemOpportunityFilters
  );

  const isMyView = page === CONFIGURE_VIEW.myDefault ? false : true;
  const isInsight = page === CONFIGURE_VIEW.insights ? true : false;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [actionType, setActionType] = useState(null);

  const showSaveWarningModal = () => {
    return new Promise((resolve) => {
      modalPromiseRef.current = resolve;
      setShowViewWarningModal(true);
    });
  };

  const handleSaveWarningResponse = (result) => {
    if (modalPromiseRef.current) modalPromiseRef.current(result);

    setShowViewWarningModal(false);

    // Avoid multiple get cardsapi call for next set of pagination on view change.
    if (isInsight) scrollToSelectedView(COMPONENT_MAPPING.Insights);
  };

  const onDuplicateHandler = async () => {
    setActionType(VIEW_ACTION_TYPE.DUPLICATE);
    setAnchorEl(null);
    var modalResult = MODAL_ACTION.PROCEED;
    if (isInsight && !saveInsightViewBtnState) {
      modalResult = await showSaveWarningModal();
      setShowViewWarningModal(false);
      if (modalResult === MODAL_ACTION.CANCEL) {
        return;
      }
    }
    const payload = {
      name: `Copy of ${currentViewRecord.name}`,
      type: INSIGHT_TYPE_CODE.GENERAL,
      owner: 'Me',
      category: VIEW_CATEGORY.CREATED,
      Id: currentViewRecord.Id,
    };

    let filters = {
      Engagements: engagementFilters,
      SitePerformance: sitePerformanceFilters,
      SiteUtilization: siteUtilizationFilters,
      Affiliations: AffiliationFilter,
      CopayAnalytics: copayAnalyticsFilters,
      ProductMix: productMixFilters,
      PayerMix: payerMixFilters,
      PolicyDetails: policyDetailsFilters,
      EcosystemOpportunity: ecosystemOpportunityFilters,
    };

    // Use filters from selectedInsightView if proceeding without saving
    if (modalResult === MODAL_ACTION.PROCEED_WITHOUT_SAVING) {
      filters = selectedInsightView?.filters || {};
    }

    // Filter out keys not accessible to the user
    filters = getAccessibleFilters(filters, componentAccessList, selectedView);

    const isProceed = modalResult !== MODAL_ACTION.CANCEL;
    const insightPayload = {
      custInsightsBrdId: custInsightsBrdId,
      name: `Copy of ${currentViewRecord.name}`,
      filters: isProceed ? buildFilterPayload(filters) : UNDEFINED,
      type: INSIGHT_TYPE_CODE.GENERAL,
      viewId: currentViewRecord.Id,
    };
    if (isInsight) {
      const response = await copyViewToInsight(insightPayload);
      const newView = {
        ...response?.result,
        filters: isProceed ? buildFilterPayload(filters) : UNDEFINED,
      };
      if (isProceed) {
        let newAllInsightViews = allInsightViews.map((item) => {
          if (item.Id === selectedInsightView?.Id) {
            return {
              ...item,
              filters: { ...filters },
            };
          }
          return item;
        });
        dispatch(setAllInsightView([newView, ...newAllInsightViews]));
      } else {
        dispatch(setAllInsightView([newView, ...allInsightViews]));
      }

      dispatch(setSelectedInsightView(newView));
      toast.success('The view has been successfully duplicated.');
    } else {
      const response = await copyViewToMyView(payload);
      dispatch(setAllMView([response.result, ...allMViews]));
      toast.success(
        'A copy of this view has been successfully created and saved.'
      );
    }
    dispatch(setSaveInsightViewBtnState(BUTTON_STATE.DISABLED));
  };

  const onDeleteHandler = () => {
    setOpenModal((pre) => ({ ...pre, isDelete: true }));
    setAnchorEl(null);
  };

  const onRenameHandler = () => {
    setOpenModal((pre) => ({ ...pre, isRename: true }));
    setAnchorEl(null);
  };

  const onAddNewViewHandler = () => {
    setActionType(VIEW_ACTION_TYPE.ADD_NEW_VIEW);
    setAnchorEl(null);
    if (!saveInsightViewBtnState) {
      setShowViewWarningModal(!showViewWarningModal);
    } else {
      if (page === 'Insights') {
        setViewModalShow(true);
      }
    }
  };

  const onCopyToMyViewHandler = async () => {
    setAnchorEl(null);
    const payload = {
      name: currentViewRecord.name,
      type: INSIGHT_TYPE_CODE.SAMPLE,
      owner: 'Me',
      category: VIEW_CATEGORY.CREATED,
      Id: currentViewRecord.Id,
    };
    const response = await copyViewToMyView(payload);
    dispatch(setAllMView([response.result, ...allMViews]));

    toast.success('The sample view has been copied to My Views.');
  };

  return (
    <>
      <ContextPopover
        anchor={anchorEl}
        onHandleClose={handleClose}
        placement='bottomRight'
        content={
          <>
            {(isMyView || isInsight) && (
              <>
                {isInsight && (
                  <div
                    className='menu-item mt-2'
                    onClick={onAddNewViewHandler}>
                    <i className={'icon icon__add'}></i>
                    <span className='ps-1'>Add New View</span>
                  </div>
                )}

                <div
                  className={isInsight ? 'menu-item' : 'menu-item mt-2'}
                  onClick={onDuplicateHandler}>
                  <i className='icon icon__copy-insight me-2'></i>
                  <span className='ps-1'>Duplicate</span>
                </div>
                <div
                  className='menu-item'
                  onClick={onRenameHandler}>
                  <i
                    className={`icon icon__configureEditInsightTile ${classes['edit-icon']}`}></i>
                  <span className='ps-1'>
                    Rename {page === 'Insights' ? 'View' : ''}
                  </span>
                </div>
                <div
                  className='menu-item mb-2'
                  onClick={onDeleteHandler}>
                  <i className='icon icon__delete-insight me-2'></i>
                  <span className='ps-1'>
                    Delete {page === 'Insights' ? 'View' : ''}
                  </span>
                </div>
              </>
            )}
            {!isMyView && (
              <div
                className='menu-item ms-1 text-nowrap width-auto p-3'
                onClick={onCopyToMyViewHandler}>
                <i className='icon icon__copy-insight me-2'></i>
                <span className='ps-1'>Copy To My Views</span>
              </div>
            )}
          </>
        }
      />
      {viewModalShow && (
        <AddNewView
          openModal={viewModalShow}
          onOpenHandler={setViewModalShow}
          page={page}
        />
      )}
      <ShareViewModal
        openModal={openModal.isShared}
        setOpenModal={setOpenModal}
      />
      <RenameViewModal
        openModal={openModal.isRename}
        setOpenModal={setOpenModal}
        currentViewRecord={currentViewRecord}
        page={page}
      />

      <DeleteViewModal
        openModal={openModal.isDelete}
        setOpenModal={setOpenModal}
        currentViewRecord={currentViewRecord}
        page={page}
        custInsightsBrdId={custInsightsBrdId}
      />
      <SaveWarningModal
        show={showViewWarningModal}
        onHide={() => handleSaveWarningResponse(MODAL_ACTION.CANCEL)}
        onSaveViewWarning={() =>
          handleSaveWarningResponse(MODAL_ACTION.PROCEED)
        }
        onProceedWithoutSave={() =>
          handleSaveWarningResponse(MODAL_ACTION.PROCEED_WITHOUT_SAVING)
        }
        viewActionType={actionType}
      />
    </>
  );
}
